<form [formGroup]="trusteeForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="form-80">
    <h1 class="blue margin">{{title}}</h1>
    <p class="lead rocal" style="margin-bottom: 0px;">{{subtitle}}</p>

    <!-- Panel 1: Trustee Info -->
    <ng-template #trusteeInfo let-i="index">
      <div *ngIf="getTrusteeFormGroup(i)">
        <div class="line-section"></div>

        <div class="row"
          [ngClass]="{'half': getTrusteeFormGroup(i).get('Category')?.value.toLowerCase().includes('corporate') || trustees[i].personalDone }">
          <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="Category" *ngIf="!trustees[i].personalDone"
            inputType="select" [selectFunction]="onTrusteeTypeChange.bind(this)" [selectParam]="i"
            [ArrayItems]="TrusteeOptions" label={{trusteeTypeLabel}} hint={{trusteeTypeHint}}
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getTrusteeFormGroup(i)" class="grid-item"
            *ngIf="getTrusteeFormGroup(i).get('Category')?.value.toLowerCase().includes('individual')"
            controlName="Relationship" inputType="select" [selectFunction]="onRelationshipChange.bind(this)"
            [selectParam]="i"
            [ArrayItems]="(hasSelfRelationship && i > selfRecords.length ? Relationships : RelationOptions)"
            label={{relationLabel}} hint={{relationHint}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>

        <div class="row half" *ngIf="getTrusteeFormGroup(i).get('Relationship')?.value === 'Other'">
          <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="Other" label='Specify Relationship'
            hint='Specify your relation to the settlor' [validationMessages]="validationMessages"
            [formErrors]="formErrors">
          </app-input>
        </div>

        <div *ngIf="getTrusteeFormGroup(i).get('Category')?.value.toLowerCase() === 'individual trustee'">
          <div class="row-alt">
            <div class="row-mini">
              <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="Title" label={{titleLabel}}
                hint={{titleHint}} inputType="auto-complete" [loadingOptions]="loadingTitles"
                [ArrayItems]="TitleOptions" required="false" [validationMessages]="validationMessages"
                [formErrors]="formErrors">
              </app-input>

              <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="FirstName" label={{fNameLabel}}
                hint={{fNameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

            </div>

            <div class="row-mini">
              <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="MiddleName" label={{mNameLabel}}
                hint={{mNameHint}} required='false' [validationMessages]="validationMessages"
                [formErrors]="formErrors"></app-input>
              <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="LastName" label={{surnameLabel}}
                hint={{surnameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            </div>

          </div>

          <div class="row">
            <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="Phone" class="grid-item" label={{phoneLabel}}
              inputType="phone" [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="Email" class="grid-item" label={{emailLabel}}
              hint={{emailLabel}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>

          <div class="row">
            <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="IDNo" label={{idLabel}} hint={{idHint}}
              [runSuggestions]="true" [altIDSuggest]="true" [suggestID]="suggestSettlors.bind(this, i)"
              [validationMessages]="validationMessages" [formErrors]="formErrors">
            </app-input>
            <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="KraPin"
              [required]="region == 1 ? 'false' : 'true' "
              [subtext]="region == 1 ? 'KRA PIN is optional' : '' "
              label={{kraPinLabel}} hint={{kraHint}}
              [validationMessages]="validationMessages" [formErrors]="formErrors">
            </app-input>
          </div>
        </div>

        <div *ngIf="getTrusteeFormGroup(i).get('Category')?.value.toLowerCase() === 'corporate trustee'">
          <div class="row">
            <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="InstitutionName" class="grid-item"
              label={{institutionNameLabel}} hint={{institutionNameHint}} [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="BusinessNature" label={{businessNatureLabel}}
              hint={{businessNatureHint}} inputType="select" [ArrayItems]="BusinessNatureOptions"
              [loadingOptions]="loadingBizNature" [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>

          <div class="row">
            <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="OrgRegNum" class="grid-item"
              label={{orgRegNumLabel}} hint={{orgRegNumHint}} [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>

            <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="KraPin" class="grid-item"
              label="Institution KRA PIN" hint={{kraHint}} [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>
        </div>

        <div class="row half">
          <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="PostalAddress" class="grid-item"
            label={{orgAddressLabel}} hint={{orgAddressHint}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>
      </div>
    </ng-template>

    <!-- Panel 2 (Institutions): Contact Info -->
    <ng-template #contactInfo let-i="index">
      <div *ngIf="getTrustees() && getTrusteeFormGroup(i)">
        <div class="line-section"></div>

        <div formArrayName="ContactPersons" *ngIf="getContacts(i).controls">
          <div *ngFor="let contact of getContacts(i).controls; let j=index" [formGroupName]="j"
            style="position: relative;">
            <div *ngIf="getContactsFormGroup(i, j)">
              <div style="height: 50px;" *ngIf="j > 1"></div>
              <div class="line-2" *ngIf="j > 0"></div>

              <p class="blue lead">
                {{'Contact Person ' + (j+1)}}
              </p>


              <div class="row-alt">
                <div class="row-mini">
                  <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="Title" label={{titleLabel}}
                    hint={{titleHint}} inputType="auto-complete" [loadingOptions]="loadingTitles"
                    [ArrayItems]="TitleOptions" required="false" [validationMessages]="validationMessages"
                    [formErrors]="formErrors">
                  </app-input>

                  <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="FirstName" label={{fNameLabel}}
                    hint={{fNameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

                </div>

                <div class="row-mini">
                  <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="MiddleName" label={{mNameLabel}}
                    hint={{mNameHint}} required='false' [validationMessages]="validationMessages"
                    [formErrors]="formErrors"></app-input>
                  <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="LastName" label={{surnameLabel}}
                    hint={{surnameHint}} [validationMessages]="validationMessages"
                    [formErrors]="formErrors"></app-input>
                </div>

              </div>

              <div class="row">
                <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="Phone" class="grid-item"
                  label={{phoneLabel}} inputType="phone" [validationMessages]="validationMessages"
                  [formErrors]="formErrors"></app-input>
                <app-input [formGroup]="getContactsFormGroup(i, j)" controlName="Email" class="grid-item"
                  label={{emailLabel}} hint={{emailLabel}} [validationMessages]="validationMessages"
                  [formErrors]="formErrors"></app-input>
              </div>

              <div class="remove-button" style="margin-top: 5px;" *ngIf="j > 0">
                <button mat-stroked-button type="button" (click)="removeContact(i, j)">
                  <div style="display: flex; flex: 1; align-items: center;">
                    <span class="button-text">
                      <u>{{ removeContactText }}</u>
                    </span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- BUTTTON Add Contact person -->
        <div class="blueStroke row" [ngClass]="{'min-55' : getContacts(i) && getContacts(i).length > 1}">
          <button mat-stroked-button [disabled]="!trusteeForm.valid" type="button" (click)="addNewContact(i)">
            <span class="button-text">
              {{ '+ Add Contact Person' }}
            </span>
          </button>
        </div>
      </div>
    </ng-template>

    <!-- Panel 3: Upload Documents -->
    <ng-template #uploadDocs let-i="index">
      <div *ngIf="getTrusteeFormGroup(i)">
        <div class="line-section"></div>

        <div *ngIf="getTrusteeFormGroup(i).get('Category')?.value.toLowerCase() === 'individual trustee'">
          <div class="row">
            <app-input controlName="IDNoImage" inputType="file" class="grid-item"
              [formGroup]="getTrusteeFormGroup(i)"
              [fileFunction]="updateIDObject.bind(this, i)"
              [existingFileName]="trustees[i]?.IDNoImage?.name != '' ? trustees[i]?.IDNoImage?.name :
                                  getTrusteeFormGroup(i).get('Relationship')?.value == 'Self' &&
                                  recordUpdate?.IDNoImage != '' ? recordUpdate?.IDNoImage?.name : '' "
              [validationMessages]="validationMessages"
              [formErrors]="formErrors"
              label={{idFileLabel}}
              hint={{idHint}} >
            </app-input>
            <app-input controlName="KraPinImage" inputType="file" class="grid-item"
              [required]="region == 1 ? 'false' : 'true' "
              [subtext]="region == 1 ? 'KRA PIN is optional' : '' "
              [formGroup]="getTrusteeFormGroup(i)"
              label={{kraFileLabel}}
              [fileFunction]="updateKraObject.bind(this, i)"
              [existingFileName]="trustees[i]?.KraPinImage?.name != '' ? trustees[i]?.KraPinImage?.name :
                                  getTrusteeFormGroup(i).get('Relationship')?.value == 'Self' &&
                                  recordUpdate?.KraPinImage != '' ? recordUpdate?.KraPinImage?.name : '' "
              [validationMessages]="validationMessages"
              [formErrors]="formErrors">
            </app-input>
          </div>

          <div class="row">
            <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="PassportImage"
              [fileFunction]="updatePassportObject.bind(this, i)"
              [existingFileName]="trustees[i]?.PassportImage?.name != '' ? trustees[i]?.PassportImage?.name : '' "
              class="grid-item" label={{passportLabel}} inputType="file" [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>

            <app-input [formGroup]="getTrusteeFormGroup(i)" class="grid-item" controlName="CvImage" label={{cvLabel}}
              inputType="file" [fileFunction]="updateCVObject.bind(this, i)"
              [existingFileName]="trustees[i]?.CvImage?.name != '' ? trustees[i]?.CvImage?.name : '' "
              [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>
        </div>

        <div *ngIf="getTrusteeFormGroup(i).get('Category')?.value.toLowerCase() === 'corporate trustee'">
          <div class="row">
            <app-input [formGroup]="getTrusteeFormGroup(i)" controlName="RegCertImage" class="grid-item"
              label={{regCertFileLabel}} inputType="file" [fileFunction]="updateRegCertObject.bind(this, i)"
              [existingFileName]="trustees[i]?.RegCertImage?.name != '' ? trustees[i]?.RegCertImage?.name : '' "
              [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getTrusteeFormGroup(i)" class="grid-item" controlName="KraPinImage"
              [fileFunction]="updateKraObject.bind(this, i)"
              [existingFileName]="trustees[i]?.KraPinImage?.name != '' ? trustees[i]?.KraPinImage?.name : '' "
              label={{kraFileLabel}} inputType="file" [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
          </div>
        </div>
      </div>
    </ng-template>

    <div formArrayName="trustees">
      <div *ngFor="let ben of getTrustees().controls; let i=index; trackBy: trackByFn" [formGroupName]="i" style="position: relative;">

        <div style="height: 80px;" *ngIf="trustees.length > 0 && i > 0"></div>
        
        <!-- Accordion -->
        <app-section [panels]="trusteePanels[i]" style="display: flex; box-sizing: border-box;">
        </app-section>

        <!-- ++++++++++++++++++++++++++++ -->

        <!-- REMOVE BUTTON -->
        <div class="action-buttons">
          <button mat-stroked-button type="button" class="remove" (click)="removeTrustee(i)"
            *ngIf="getTrustees().length > 1">
            <div style="display: flex; flex: 1; align-items: center;">
              <span class="button-text">
                <u>{{
                  getTrustees().controls.length - 1 === i
                  ? removeButtonText
                  : removeBenText
                  }}</u>
              </span>
              <span class="spinning-global" *ngIf="currentIndex === i && loadingRemove">
                <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4">
                </mat-progress-spinner>
              </span>
            </div>
          </button>

          <button class="update" mat-stroked-button type="button" *ngIf="getTrustees() && !confirmFormMatchesRecord(i)"
            [disabled]="loading || loadingRemove" (click)="updateRecord(i)">
            <span class="button-text">
              {{ 'Update Trustee ' +(i+1) }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- BUTTTON Add Trustee -->
    <div class="blueStroke row"
      [ngClass]="{'min-55' : (getTrustees() && getTrustees().length > 1) || trustees[trustees.length-1].done}">
      <button mat-stroked-button *ngIf="trustees[trustees.length-1] && trustees[trustees.length-1].done" type="button"
        (click)="addTrustee()">
        <span class="button-text">
          {{ '+ Add New Trustee'}}
        </span>
      </button>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;" [service]="estateControlService"
    [formValid]="trusteeForm.valid || trustees[trustees.length-1].done === true"
    [showContinue]="trusteeForm.pristine || trusteeForm.valid || trustees[trustees.length-1].done ? 'true' : 'false'"
    [saveFunction]="updateProgress.bind(this)" [text]="
      loading ? loadingText :
      trustees[trustees.length-1].done ? 'Next' :
      trustees[trustees.length-1].contactsDone ? 'Upload Documents' :
      trustees[trustees.length-1].personalDone ? 'Update Details' : 'Save Details' "
    [buttonClickHandler]="submitForm.bind(this)">
  </app-form-bottom>
</form>